
export default {
    props: {
        mode: {
            type: String,
            default: 'page',
        },
        redirect: {
            type: String,
            default: null,
        },
    },
    data () {
        return {
            email: this.$route.query.email || null,
            dob: null
        }
    },
    computed: {
        isPage () {
            return this.mode === 'page'
        },
        isModal () {
            return this.mode === 'modal'
        },
        isInline () {
            return this.mode === 'inline'
        },
    },
    methods: {
        async sendLoginLink () {
            const { error } = await this.$try('sendLoginLink', ({ email: this.email, dob: this.dob, redirect: this.redirect || this.$route.query.r || '' }))
            if (!error) {
                if (this.isModal || this.isInline) {
                    this.$emit('close')
                    this.$alert({ message: 'If we have your email/dob on file, we should have sent you a login link. Refresh this page after you\'ve logged in or use the link in your email.', variant: 'success' })
                } else {
                    this.$alert({ message: 'If we have your email/dob on file, we should have sent you a login link', variant: 'success' })
                }
                this.email = null
                this.dob = null
            }
        }
    },
}

